import QuoteMatchingDistributionRuleDetailSection from '../../../sections/AdminDashboard/Configuration/QuoteMatchingDistributionRuleDetail';

const QuoteMatchingDistributionRuleDetail = () => <QuoteMatchingDistributionRuleDetailSection />;

export default QuoteMatchingDistributionRuleDetail;
